import React from 'react';
import { Button, Drawer, Space, Table, Typography } from 'antd';
import { PlayCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import type { SyncTask, SyncTaskRun } from './types';
import { createRunColumns } from './settingsColumns';

type Props = {
  open: boolean;
  task: SyncTask | null;
  runs: SyncTaskRun[];
  loading: boolean;
  onClose: () => void;
  onRefresh: (taskId: number) => void;
  onRun: (task: SyncTask) => void;
};

const SyncTaskRunsDrawer: React.FC<Props> = ({ open, task, runs, loading, onClose, onRefresh, onRun }) => (
  <Drawer
    title={task ? `${task.taskName} - 最近执行记录` : '执行记录'}
    placement="right"
    width={920}
    open={open}
    onClose={onClose}
    extra={
      task ? (
        <Space>
          <Button onClick={() => onRefresh(task.id)} icon={<ReloadOutlined />}>刷新记录</Button>
          <Button type="primary" icon={<PlayCircleOutlined />} onClick={() => onRun(task)} disabled={task.lastRunStatus === 'running'}>
            立即执行
          </Button>
        </Space>
      ) : null
    }
  >
    <Table
      rowKey="id"
      columns={createRunColumns()}
      dataSource={runs}
      loading={loading}
      size="small"
      pagination={false}
      expandable={{
        expandedRowRender: (record) => (
          <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <Typography.Text strong>消息</Typography.Text>
            <Typography.Text>{record.message || '-'}</Typography.Text>
            {record.errorDetail ? (
              <>
                <Typography.Text strong>错误详情</Typography.Text>
                <Typography.Text type="danger">{record.errorDetail}</Typography.Text>
              </>
            ) : null}
            {record.notificationMessage ? (
              <>
                <Typography.Text strong>通知结果</Typography.Text>
                <Typography.Text type={record.notificationStatus === 'failed' ? 'danger' : undefined}>
                  {record.notificationMessage}
                </Typography.Text>
              </>
            ) : null}
          </Space>
        ),
        rowExpandable: (record) => Boolean(record.errorDetail || record.message || record.notificationMessage),
      }}
    />
  </Drawer>
);

export default SyncTaskRunsDrawer;
